import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Fragment } from "react";
import { func, shape, string } from "prop-types";
import { useForgotPassword } from "@magento/peregrine/lib/talons/ForgotPassword/useForgotPassword";
import FormError from "@overrides_venia/venia-ui/components/FormError";
import ForgotPasswordForm from "./ForgotPasswordForm";
import FormSubmissionSuccessful from "./FormSubmissionSuccessful";
import HeaderBasic from "../../../../components/HeaderBasic";
import forgotPasswordOperations from "./forgotPassword.gql";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./forgotPassword.module.scss";

//Assets
import { useIntl } from "react-intl";
var ForgotPassword = props => {
  var {
    initialValues,
    onCancel
  } = props;
  var {
    formatMessage
  } = useIntl();
  var talonProps = useForgotPassword(_objectSpread({
    onCancel
  }, forgotPasswordOperations));
  var {
    forgotPasswordEmail,
    formErrors,
    handleCancel,
    handleFormSubmit,
    hasCompleted,
    isResettingPassword
  } = talonProps;
  var classes = mergeClasses(defaultClasses, props.classes);
  var children = hasCompleted ? /*#__PURE__*/React.createElement(FormSubmissionSuccessful, {
    email: forgotPasswordEmail
  }) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ForgotPasswordForm, {
    initialValues: initialValues,
    isResettingPassword: isResettingPassword,
    onSubmit: handleFormSubmit,
    onCancel: handleCancel
  }), /*#__PURE__*/React.createElement(FormError, {
    errors: formErrors,
    id: "forgot-password"
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.pwdforgot_container, " uk-background-cream")
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.page_wrapper
  }, /*#__PURE__*/React.createElement(HeaderBasic, {
    color: "black",
    title: formatMessage({
      id: "signin.label.forgot.password"
    }),
    path: "#offcanvas-login-dx"
  }), /*#__PURE__*/React.createElement("div", {
    className: "uk-container"
  }, children)));
};
export default ForgotPassword;
ForgotPassword.propTypes = {
  classes: shape({
    instructions: string,
    root: string
  }),
  initialValues: shape({
    email: string
  }),
  onCancel: func
};
ForgotPassword.defaultProps = {
  onCancel: () => {}
};